module.exports = __webpack_public_path__ + "static/media/993107.165e4a77.png";